<template>
    <transition name="cookie" appear>
        <div class="PopupBrowser" v-if="!isAccepted">
            <span class="PopupBrowser-title">Information</span>
            <span class="PopupBrowser-text">This website uses recent web technologies. To provides you the best experience, please update you're browser to a most recent one</span>
            <button class="PopupBrowser-btn" @click="onBtnClick">Got it</button>
        </div>
    </transition>
</template>

<script>
import { getCookie } from '@/utils/getCookie.js'
import { setCookie } from '@/utils/setCookie.js'
import { eraseCookie } from '@/utils/eraseCookie.js'

export default {
    name: 'PopupBrowser',

    data() {
        return {
            isAccepted : false,
            cookieName : 'dillingerCookie'
        }
    },

    created(){
        this.checkCookie();
    },

    methods: {
        writeCookie() {
            setCookie( this.cookieName, +new Date(), 1 )
            this.isAccepted = true
        },

        checkCookie() {
            this.isAccepted = !!getCookie( this.cookieName )
        },

        onBtnClick(){
            this.writeCookie()
        }
    },
}
</script>


<style scoped lang="scss">
    .PopupBrowser{
        position: fixed;
        top: 180px;
        right: 60px;
        width: 363px;
        z-index: zindex(cookie);
        font-family: sans-serif;

        background-color: color(black);

        padding: 21px 17px;
        padding-right: 100px;

        transition: transform .6s $ease-out-quint, visibility 0.6s linear;
        transform: translateZ(0);

        @include respond-to(sm){
            top: auto;
            bottom: 0;
            right: 0;
            width: 100%;
        }
        
        &-title{
            display: block;
            font-size: rem(12px);
            text-transform: uppercase;
            font-weight: bold;

            letter-spacing: 1px;
            line-height: 2;
        }

        &-text{
            display: block;
            font-size: rem(12px);
            line-height: 16px;
        }

        &-btn{
            position: absolute;
            bottom: 8px;
            right: 8px;

            display: block;

            font-size: rem(12px);
            color: color(white);
            padding: 10px;

            text-transform: uppercase;
            font-weight: bold;
            font-family: sans-serif;
        }
    }


    // // // // // // // // /
    // TRANSITION HANDLING //
    // // // // // // // // /
    
    .cookie-enter, .cookie-leave-to {
        transform: translateX( 421px) translateZ(0);
        visibility: hidden;
    }
</style>
